import React, { Component } from 'react'
import Form from '../components/Form/Form'
import templates from '../components/FormTemplates'
import actions from '../actions/storingen'
import { connect } from 'react-redux'
import scrollTo from "../utils/scrollTo";
import dynamicPortal from '../utils/dynamicPortal';
import map from '../api/mapping/storingen';
import connection from '../api/config/connection';

export class StoringenFormPortal extends Component {
  constructor() {
    super();
    this.formRef = React.createRef()
  }

  render() {
    return dynamicPortal.load('.js-react-storingen-form', (config) => {
      config.submit.method = "GET";
      config.submit.async = true;

      //Todo: Remove when implemented by the Moop api
      if (config.mockCancelledStops) {
        this.mockCancelledStops = true
      }

      return (
        <div className="theme--accent">
          <div className="container container--center container--clearfix">
            <div className="container container--margin">
              <Form
                ref={this.formRef}
                config={config}
                templates={templates}
                axios={connection.instance()}
                onSubmit={async (values) => await this.handleSubmit(values)}
                onSubmitted={async (response, values) => await this.handleSubmitted(response, values)}
                onError={(error) => this.handleError(error)}
              />
            </div>
          </div>
        </div>
      )
    })
  }

  async handleSubmit() {
    this.props.requestStoringen();
  }

  handleError() {
    this.props.failedStoringen();
  }

  async handleSubmitted(response, values) {
    if (!response.data || !response.data.length) {
      this.props.receivedStoringen([]);
      return;
    }
    if (response.data.error) {
      console.error(response.data.error.msg);
      this.props.receivedStoringen([]);
      return;
    }

    let results = []
    try {
      results = response.data || []
    } catch (ex) { }

    let storingen = map(results)
    this.props.receivedStoringen(storingen, values);

    const resultsElement = document.querySelector('.js-react-storingen');
    if (resultsElement) {
      scrollTo.scrollToElement(resultsElement, -40);
    }
  }
}

export default connect(
  state => ({
    storingen: state.storingen
  }),{
    requestStoringen: actions.request,
    receivedStoringen: actions.received,
    failedStoringen: actions.failed
  }
)(StoringenFormPortal)


// WEBPACK FOOTER //
// ./src/portals/StoringenFormPortal.js